import React from 'react'

export default function CompanyEvents() {
  return (
    <div>CompanyEvents</div>
  )
}
